import { useEffect, useRef } from 'react';

export default function MouthpieceHero() {
  const bgRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Background image fade-in
    const bgTimer = setTimeout(() => {
      bgRef.current?.querySelector('.fade-in')?.classList.add('visible');
    }, 50);

    // Hero text items: staggered entrance
    const itemTimer = setTimeout(() => {
      contentRef.current?.querySelectorAll('.hero-item').forEach((el) => {
        el.classList.add('visible');
      });
    }, 150);

    return () => {
      clearTimeout(bgTimer);
      clearTimeout(itemTimer);
    };
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0" ref={bgRef}>
        <img
          alt="診断レポート"
          className="w-full h-full object-cover object-top fade-in"
          fetchPriority="high"
          src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1856x2113_v-frms_webp_90955c9c-fd92-4835-a66d-09a989961acb_small.webp"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/70 to-white/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        <div ref={contentRef} className="flex flex-col items-center gap-0">
          <span
            className="hero-item inline-block text-white px-4 py-1 rounded-full text-sm font-medium mb-6"
            style={{ backgroundColor: '#3E5F8F' }}
          >
            無料|診断レポート
          </span>
          <h1
            className="hero-item text-4xl md:text-5xl lg:text-6xl font-normal text-gray-900 mb-6 leading-tight"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            札幌のマウスピース矯正、あなたに合う<br />方法を一緒に整理します。
          </h1>
          <p className="hero-item text-lg md:text-xl text-gray-700 mb-10 leading-relaxed">
            診断結果をもとに、あなた専用 矯正プラン比較レポートを無料で作成。<br />
            その場で決めなくて大丈夫。
          </p>
          <div className="hero-item">
            <a
              href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#3E5F8F' }}
            >
              無料診断を予約する
              <i className="ri-arrow-right-line" />
            </a>
          </div>
          <p className="hero-item text-sm text-gray-600 mt-6">
            費用が発生するのは、治療を希望され契約する場合のみです
          </p>
          <a
            href="#report"
            className="hero-item inline-flex items-center gap-1 mt-4 text-sm font-medium"
            style={{ color: '#3E5F8F' }}
          >
            あなた専用 矯正プラン比較レポートとは
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>
      </div>
    </section>
  );
}